import { render } from "./StockDetailPage.vue?vue&type=template&id=03d87774&scoped=true"
import script from "./StockDetailPage.vue?vue&type=script&lang=js"
export * from "./StockDetailPage.vue?vue&type=script&lang=js"

import "./StockDetailPage.vue?vue&type=style&index=0&id=03d87774&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d87774"]])

export default __exports__